import { environment } from '@/assets/environment';
import { IErrorResponse } from '@/models/errors/error-response.model';
import { IWheelsFilter } from '@/models/store/filter-data/wheels-filter.model';
import { IHelperWheelData } from '@/models/store/wheels/helper-wheel-data.model';
import { IWheel } from '@/models/store/wheels/wheel.model';
import { IWheelsState } from '@/models/store/wheels/wheels-state.model';
import { Module } from 'vuex';

export const wheelsModule: Module<IWheelsState, unknown> = {
    state: {
        wheels: [],
        helperWheelsData: {
            brands: [],
            wheelTypes: [],
            radiuses: [],
            widths: [],
            pcds: [],
            ets: [],
            dias: [],
        },
    },

    actions: {
        fetchWheels: async (
            { commit },
            payload: { pageNumber: number; count: number; wheelsFilter: IWheelsFilter },
        ): Promise<void> => {
            const params = new URLSearchParams();
            params.append('pageNumber', `${payload.pageNumber}`);
            params.append('count', `${payload.count}`);
            if (payload.wheelsFilter.typeName)
                params.append('typeName', payload.wheelsFilter.typeName);
            if (payload.wheelsFilter.brand) params.append('brand', payload.wheelsFilter.brand);
            if (payload.wheelsFilter.wheelType)
                params.append('wheelType', payload.wheelsFilter.wheelType);
            if (payload.wheelsFilter.radius) params.append('radius', payload.wheelsFilter.radius);
            if (payload.wheelsFilter.width) params.append('width', payload.wheelsFilter.width);
            if (payload.wheelsFilter.pcd) params.append('pcd', payload.wheelsFilter.pcd);
            if (payload.wheelsFilter.et) params.append('et', payload.wheelsFilter.et);
            if (payload.wheelsFilter.startEt)
                params.append('startEt', payload.wheelsFilter.startEt);
            if (payload.wheelsFilter.endEt) params.append('endEt', payload.wheelsFilter.endEt);
            if (payload.wheelsFilter.dia) params.append('dia', payload.wheelsFilter.dia);

            const response = await fetch(`${environment.baseUrl}/api/wheels?` + params, {
                method: 'get',
                headers: {
                    'x-app': 'secret_admin',
                    'Content-type': 'application/json',
                    auth: 'db75 XVU3d82G',
                },
            });

            if (!response.ok) {
                const errorObject: IErrorResponse = await response.json();
                commit('setSnackbarState', {
                    status: true,
                    text: errorObject.error,
                    isError: true,
                });
                return;
            }

            const wheelsData = await response.json();
            commit('setPaginationLength', wheelsData.length);
            commit('setWheels', wheelsData.data);
        },

        fetchHelperWheelsData: async ({ commit }) => {
            const response = await fetch(`${environment.baseUrl}/api/helper-wheels`, {
                method: 'get',
                headers: {
                    'x-app': 'secret_admin',
                    'Content-type': 'application/json',
                },
            });

            if (!response.ok) {
                const errorObject: IErrorResponse = await response.json();
                commit('setSnackbarState', {
                    status: true,
                    text: errorObject.error,
                    isError: true,
                });
                return;
            }

            const filterData = (await response.json()).data;
            commit('setWheelsHelperData', filterData);
        },
    },

    mutations: {
        setWheels: (store, payload: IWheel[]): void => {
            store.wheels = [...payload];
        },
        setWheelsHelperData: (store, payload: IHelperWheelData): void => {
            store.helperWheelsData = { ...payload };
        },
    },

    getters: {
        getWheels: (store) => store.wheels,
        getHelperWheelData: (store) => store.helperWheelsData,
    },
};
